/**
 * @fileoverview Who wrote a lesson's notes — the instructor, or Hans?
 *
 * Families read a lesson summary as a message from their teacher, so the
 * provenance has to be explicit rather than inferred from the absence of a
 * "Summarized by Hans" line. A typed (manual) lesson is instructor-written by
 * definition; a recorded lesson is AI-summarised unless the instructor says
 * otherwise, which they can — an instructor who rewrites a generated summary
 * wholesale should be able to sign it.
 *
 * `instructor_written` is therefore a nullable override, not a duplicate of
 * `manual`: absent means "derive it", which keeps every lesson recorded before
 * this shipped labelled correctly with no backfill.
 *
 * Mirrored by `models.is_instructor_written` (backend) and
 * `mobile/src/utils/lessonAuthorship.js`.
 */

/**
 * @param {Object|null|undefined} lesson
 * @returns {boolean} True when the notes should be presented as the
 *   instructor's own writing rather than an AI summary.
 */
export function isInstructorWritten(lesson) {
  if (!lesson) return false;
  if (typeof lesson.instructor_written === "boolean") return lesson.instructor_written;
  return !!lesson.manual;
}
